
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusservicepunechakan() {



    const cardData =
    {
        keyword: 'Corporate Cabs and Bus Services in Chakan',
        heading: 'etravo : Corporate Cabs and Bus Services in Chakan ',
        headingDescription: 'eTravo offers dependable Corporate Cab and Bus Services in Chakan, one of Maharashtra’s major industrial hubs. Designed to support the daily transportation needs of manufacturing units, warehouses, and corporate facilities, our services include executive cabs for official travel and spacious buses for employee commutes and shift operations. With a focus on punctuality, safety, and comfort, our GPS-enabled vehicles and professional drivers ensure seamless travel experiences. Choose eTravo in Chakan for scalable, reliable, and cost-effective corporate mobility solutions.',

        top: 'Top Places to Visit in Chakan with etravo',
       "topPlaces": [
    {
      "title": "Chakan Fort (Sangram Durga)",
      "description": "A 14th-century land fort known for its historical significance, especially the 1660 siege led by Mughal general Shaista Khan. The fort showcases Maratha resilience and offers insights into India's rich history."
    },
    {
      "title": "Chakreshwar Temple",
      "description": "An ancient temple dedicated to Lord Vishnu in his Varaha avatar. Located within the Chakan Fort complex, it features rare carvings and holds mythological importance."
    },
    {
      "title": "Khandoba Temple",
      "description": "A revered temple dedicated to Lord Khandoba, attracting devotees year-round. It's especially vibrant during local festivals and offers a glimpse into regional religious practices."
    },
    {
      "title": "Jalaram Temple",
      "description": "A serene temple honoring Saint Jalaram Bapa, known for its peaceful ambiance and spiritual significance among devotees."
    },
    {
      "title": "Saint Tukaram Gatha Mandir",
      "description": "Located in nearby Dehu, this temple is dedicated to the revered Marathi saint Tukaram. It's a spiritual hub, especially during the annual Tukaram Palakhi procession."
    },
    {
      "title": "Bird Valley Udyan",
      "description": "A picturesque park in Chinchwad, ideal for nature enthusiasts. It features a serene lake, diverse bird species, and well-maintained walking trails."
    },
    {
      "title": "Bhuleshwar Temple",
      "description": "Situated about 40 km from Chakan, this ancient temple dedicated to Lord Shiva is renowned for its unique architecture and intricate carvings."
    },
    {
      "title": "Pimpri-Chinchwad Science Park",
      "description": "An educational attraction featuring interactive exhibits on science and technology, making it a fun visit for families and students."
    },
    {
      "title": "Prati Shirdi Sai Baba Temple",
      "description": "A replica of the Shirdi Sai Baba Temple, offering devotees a tranquil space for worship and reflection."
    },
    {
      "title": "Japalouppe Equestrian Farm",
      "description": "An equestrian center offering horse riding experiences, training sessions, and farm tours, suitable for families and animal lovers."
    }
  ],
    "services": [
    {
      "name": "Chakan MIDC Corporate Transport",
      "description": "eTravo offers comprehensive corporate transport solutions in Chakan MIDC, designed to streamline employee commuting and business travel. Our services include scheduled shuttle buses, executive cab hires, and customized transport plans to meet the unique demands of corporate clients operating in the industrial hub of Chakan."
    },
    {
      "name": "Bus & Cab Services for Corporates in Chakan",
      "description": "Providing reliable bus and cab services for corporates in Chakan, eTravo ensures timely and safe transportation for your workforce. Whether you need daily office shuttle buses or individual cabs for executives, our fleet of well-maintained vehicles and professional drivers deliver a comfortable travel experience."
    },
    {
      "name": "Daily Office Shuttle in Chakan MIDC",
      "description": "Our daily office shuttle services in Chakan MIDC help companies efficiently manage employee commutes. With flexible routes and schedules tailored to your shift timings, eTravo guarantees punctual pickups and drops, reducing employee tardiness and improving overall productivity."
    },
    {
      "name": "Staff Pickup and Drop Services Chakan",
      "description": "eTravo specializes in staff pickup and drop services across Chakan MIDC, offering safe, reliable, and cost-effective transport solutions. We focus on comfort and safety with well-maintained vehicles and trained drivers, making daily travel convenient for your employees."
    },
    {
      "name": "Corporate Event Transportation Chakan",
      "description": "For corporate events in Chakan, eTravo provides dedicated transportation services including buses and cabs to accommodate groups of any size. Our event transport solutions ensure seamless travel logistics, allowing your team to focus on the event while we handle the commute."
    },
    {
      "name": "Reliable Business Commute Options in Chakan",
      "description": "eTravo offers reliable business commute options in Chakan, tailored to suit diverse corporate needs. From individual cabs to group bus rentals, our flexible services help reduce transportation challenges, improve employee satisfaction, and support smooth daily operations."
    },
    {
      "name": "Cab Rentals for Executives in Chakan",
      "description": "Experience premium cab rentals for corporate executives in Chakan with eTravo. Our luxury vehicles, driven by professional chauffeurs, provide a secure and comfortable mode of transport for business meetings, airport transfers, and daily commutes, ensuring executives travel in style and on schedule."
    }
  ],
  "tableData": [
    ["Chakan MIDC Corporate Transport", "Bus & Cab Services for Corporates in Chakan"],
    ["Daily Office Shuttle in Chakan MIDC", "Staff Pickup and Drop Services Chakan"],
    ["Corporate Event Transportation Chakan", "Reliable Business Commute Options in Chakan"],
    ["Cab Rentals for Executives in Chakan", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Efficient Corporate Transport Services in Chakan",
        "WhyChoosedescription": "Chakan is home to some of India’s largest manufacturing and automotive companies, and eTravo is your reliable partner for managing employee transport in this high-demand industrial zone. We ensure timely, safe, and comfortable cab and bus services that support both small enterprises and large multinational operations."
    },
    {
        "WhyChooseheading": "Fleet Designed for Industrial and Executive Mobility",
        "WhyChoosedescription": "Our fleet includes air-conditioned buses for high-volume staff transportation, comfortable tempo travellers for mid-size teams, and executive cabs and SUVs for senior management and guests. All vehicles are GPS-enabled, well-maintained, and optimized for both long and short-distance travel within and beyond Chakan."
    },
    {
        "WhyChooseheading": "Shift-Based Transport with 24/7 Availability",
        "WhyChoosedescription": "Manufacturing and logistics companies in Chakan often operate round the clock. eTravo offers transport services tailored to shift-based operations—early morning, late night, or multiple shifts. Our system supports complex scheduling and ensures seamless, dependable movement for your entire workforce."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our drivers are trained professionals, background-verified, and familiar with Chakan’s industrial layout, internal roads, security gates, and alternate routes. Their local knowledge ensures on-time service even during peak traffic or roadwork detours, minimizing any disruption to your operations."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Flexible Billing Options",
        "WhyChoosedescription": "With eTravo, you benefit from transparent, no-surprise pricing. We offer corporate packages with monthly invoicing, GST compliance, and itemized billing so that your transport spend stays within budget and is easy to track. Perfect for procurement and finance teams."
    },
    {
        "WhyChooseheading": "Safety, Hygiene, and Compliance at the Core",
        "WhyChoosedescription": "All our vehicles are equipped with seat belts, first aid kits, GPS tracking, and fire extinguishers. Regular cleaning and sanitization protocols are strictly followed. We adhere to all transport safety regulations, ensuring the health and security of your employees."
    },
    {
        "WhyChooseheading": "24/7 Support and Real-Time Ride Monitoring",
        "WhyChoosedescription": "eTravo provides round-the-clock customer support and live tracking tools. HR and admin teams can view real-time location updates, receive ETA alerts, and manage last-minute booking adjustments through our centralized dashboard or with the help of a dedicated account manager."
    },
    {
        "WhyChooseheading": "Custom Transport Solutions for Chakan-Based Industries",
        "WhyChoosedescription": "Whether your company needs dedicated buses for multiple plants, VIP cab services, or intercity logistics for technical teams, we offer customizable plans to fit your operations. From daily commutes to special events, eTravo adapts to your transport requirements as your business grows."
    }
]




































    }

// Corporate Cabs and Bus Services in Chakan – eTravo

const faqData = [
    [
        {
            question: 'What services does eTravo provide for corporate transport in Chakan?',
            answer: 'eTravo offers end-to-end corporate cab and bus services in Chakan, including daily employee commutes, executive travel, shift-based pickups, intercity meetings, and factory visit transportation.',
        },
        {
            question: 'Can eTravo manage multi-shift transportation for manufacturing units in Chakan MIDC?',
            answer: 'Yes, we specialize in handling shift-based logistics for large-scale industrial operations. Our service ensures timely pickups and drops with optimized route planning and fleet rotation.',
        },
        {
            question: 'What types of vehicles are available for corporate clients in Chakan?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses with 13–50 seats — ideal for both executive-level transport and mass employee movement.',
        },
        {
            question: 'Are GPS tracking and safety compliance included in the service?',
            answer: 'Absolutely. All vehicles are GPS-enabled with real-time tracking. We also provide driver verification, trip reporting, and adherence to corporate safety standards.',
        },
        {
            question: 'Does eTravo provide intercity or outstation travel from Chakan?',
            answer: 'Yes, we offer cabs and buses for corporate intercity travel to locations like Pune, Nashik, Mumbai, and beyond, complete with scheduling, tracking, and full coordination.',
        },
        {
            question: 'Will there be a dedicated support team for our transport needs in Chakan?',
            answer: 'Yes, eTravo assigns a dedicated account manager to each corporate client to handle daily operations, emergency support, route changes, and performance tracking.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Swapnil More',
        designation: 'Admin Supervisor, PowerMatrix AutoTech',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s transport service in Chakan has been a game-changer for us. Their team is punctual and professional, and they’ve simplified our shift transport completely.”',
    },
    {
        name: 'Ms. Karishma Patil',
        designation: 'HR Officer, MechaForge India Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’re very happy with eTravo’s cab and bus service in Chakan. Their vehicles are well-maintained and the coordination is smooth even during peak shifts.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cabs and Bus Services in Chakan",
  "image": "https://www.etravo.in/images/keyword/corporate-cabs-bus-chakan.jpg",
  "description": "Reliable corporate cab and bus services in Chakan MIDC by eTravo. Perfect for daily office shuttles, staff pickup and drop, corporate event transportation, and executive cab rentals with comfortable and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cabs-and-bus-services-in-chakan"
  }
};






    return (
        <div>
<Helmet>
  <title>Corporate Cabs and Bus Services in Chakan | Office Shuttle & Corporate Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Chakan MIDC with eTravo for daily office shuttles, staff pickup and drop, and corporate event transportation. Reliable and comfortable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/22.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusservicepunechakan;